import forEach from 'lodash/forEach';

const externalScriptsRequested = {};

export function loadExternalScript({ onload, onerror, async, src, dataset }) {
  if (!externalScriptsRequested[src]) {
    if (src) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        forEach(dataset, (value, key) => {
          if (key && value) {
            script.dataset[key] = value;
          }
        });
        script.onload = resolve;
        script.onerror = reject;
        script.async = false;
        script.src = src;
        document.body.appendChild(script);
        externalScriptsRequested[src] = true;
      });
    }
    return Promise.reject('Url was not defined');
  }
  return Promise.resolve('Cached');
}
